const init = () => {
  const isStickyHeaderPresent = $('.feature-comparison[data-sticky-header="yes"]').length && $(window).width() >= 768; // 48rem for tablet
  $('.table-group').click(function (event) {
    const $tableGroup = $(this);
    $tableGroup.find('.arrow-icon').toggleClass('active');
    $tableGroup.closest('.table').children('tbody').toggleClass('hide');
  });

  // PricingV3
  $('.pricing-table-mobile-view-options.desktop-view .show-more-wrapper').click(function (event) {
    const $viewMore = $(this);
    const $pricingPlanWrapper = $viewMore.closest('.pricing-table-v2');
    $pricingPlanWrapper.find('.limitExceeded').show();
    $viewMore.hide();
  });
  $('.tab').click(function () {
    const $clickedTab = $(this);
    if (!$clickedTab.parent().hasClass('active')) {
      const $tabWrapper = $clickedTab.closest('.horizontal-tab-wrapper');
      $tabWrapper.find('.nav-tablist .active').attr({
        'aria-selected': false,
        tabindex: -1
      }).removeClass('active');
      $clickedTab.parent().attr({
        'aria-selected': true,
        tabindex: 0
      }).addClass('active');
      $tabWrapper.find('[data-tabcontent]').hide();
      $tabWrapper.find(`[data-tabcontent="${$clickedTab.data('toggle')}"]`).show();
      $selectedTable = $tabWrapper.find(`[data-tabcontent="${$clickedTab.data('toggle')}"]`);
      $selectedTable.show();

      // PricingV3
      const $addOnTabWrapper = $tabWrapper.siblings('.pricing-v3');
      $addOnTabWrapper.find('[data-tabcontent]').hide();
      $addOnTabWrapper.find(`[data-tabcontent="${$clickedTab.data('toggle')}"]`).show();

      if (isStickyHeaderPresent && $clickedTab.closest('.feature-comparison').data('sticky-header') === 'yes') {
        calculateParameters($selectedTable);
      }
      // Enables monthly-yearly toggle
      const $tabContent = $tabWrapper.find(`[data-tabcontent="${$clickedTab.data('toggle')}"]`);
      const defaultView = $tabContent.data('default-view');
      if (defaultView) {
        const index = $clickedTab.data('toggle').split('tab')[1];
        if (defaultView === 'monthly') {
          $tabContent.find(`[data-index="${index}"]`).prev().prop('checked', false);
        } else {
          $tabContent.find(`[data-index="${index}"]`).prev().prop('checked', true);
        }
        if ($tabContent.find('.pricing-toggle')) {
          $tabWrapper.find('.nav-tablist').css('margin-bottom', '40px');
          $tabContent.find('.tab-monthly-yearly-content').hide();
          $tabContent.find('.pricing-package').removeClass('active');
          $tabContent.find(`[data-pricing-toggle="pricing-${defaultView}${index}"]`).addClass('active');
          $tabContent.find(`[data-tabcontent="tab${index}${defaultView}-tab"]`).show();
        } else {
          $tabWrapper.find('.nav-tablist').css('margin-bottom', '60px');
        }
      }
    }
  });

  if ($.find(`[data-pricing-toggle="pricing-monthly1"]`)) {
    $('.nav-tablist').css('margin-bottom', '40px');
  }

  let $selectedTable, stickyNavHeight, $tableHeading, $firstContentTable, tableHeadingHeight, tableHeight;
  const calculateParameters = ($selectedTable) => {
    stickyNavHeight = 0;
    $tableHeading = $selectedTable.find('.table-headings')[0];
    $firstContentTable = $selectedTable.find('.table-headings + .table')[0];
    tableHeadingHeight = $tableHeading.getBoundingClientRect().height;
    tableHeight = $selectedTable.closest('.pricing-tab-wrapper')[0].getBoundingClientRect().height;
  };
  // Sticky header functionality
  if (isStickyHeaderPresent) {
    $(window).on('scroll', function () {
      $('.feature-comparison[data-sticky-header="yes"]').each(function (i) {
        const $this = $(this);
        if (this.getBoundingClientRect().top < stickyNavHeight) {
          const $activeTab = $this.find('.nav-tablist li.active a');
          const currentTab = $activeTab.length ? $activeTab.data('toggle') : 'tab1';
          calculateParameters($this.find(`[data-tabcontent="${currentTab}"]`));
        } else {
          // to remove table-stuck if missed to remove due to fast scrolling
          $this.find('.table-headings')[0].classList.remove('table-stuck');
        }
      });
      if (!stickyNavHeight && $('header .nav-sticky')[0]) {
        stickyNavHeight = $('header .nav-sticky')[0].clientHeight;
      }
      const tableHeadingTop = $firstContentTable.getBoundingClientRect().top - tableHeadingHeight;
      if (tableHeadingTop > stickyNavHeight || tableHeight - tableHeadingHeight * 3 < Math.abs(tableHeadingTop) + stickyNavHeight) {
        $tableHeading.classList.remove('table-stuck');
        $firstContentTable.style.marginTop = '0px';
      } else if (tableHeadingTop < stickyNavHeight) {
        $tableHeading.classList.add('table-stuck');
        $tableHeading.style.top = stickyNavHeight + 'px';
        $firstContentTable.style.marginTop = tableHeadingHeight + 'px';
      }
    });
    // initially populate values with first tab
    calculateParameters($('.feature-comparison[data-sticky-header="yes"] [data-tabcontent="tab1"]'));
  }

  $('.pricing-package, .pricing-toggle-label').on('click', function () {
    const $clickedTab = $(this);
    const $parent = $(this).parent();
    const id = $clickedTab.data('index');
    const checkBox = $parent.find('input');
    if (($clickedTab.hasClass('pricing-monthly') && !checkBox.is(':checked')) || ($clickedTab.hasClass('pricing-yearly') && checkBox.is(':checked'))) {
      return;
    }
    if (!$clickedTab.hasClass('pricing-toggle-label')) {
      checkBox.prop('checked', !checkBox.prop('checked'));
    }
    toggleMontlyYearlyTab(id);
  });

  function toggleMontlyYearlyTab (id) {
    $(`[data-pricing-toggle="${'pricing-monthly' + id}"]`).toggleClass('active');
    $(`[data-pricing-toggle="${'pricing-yearly' + id}"]`).toggleClass('active');
    $(`[data-tabcontent="${'tab' + id + 'yearly-tab'}"]`).toggle();
    $(`[data-tabcontent="${'tab' + id + 'monthly-tab'}"]`).toggle();
  }
};

const setDefaulttogglefn = (val) => {
  console.log(val);
};
export default { init, setDefaulttogglefn };
